// Example
// import commponent from './vueComponent.vue'
// import directive from './v-directive'
// import navTop from './navTop.vue'
import vueCalendar from './vueCalendar.vue'
import vueDropdown from './vueDropdown.vue'
import multiSelect from './multiSelect.vue'

import storage from './directives/v-storage'
import touch from './directives/v-touch'
import video from './directives/v-video'

import datePicker from './datePicker.vue'
import navTop from './navTop.vue'
import navLeft from './navLeft.vue'
import postSticker from './postSticker.vue'
import newIdeaModal from './newIdeaModal.vue'
import adminModal from './adminModal.vue'
import confirmModal from './confirmModal.vue'
import menuTop from './menuTop.vue'
import svgIcon from './svgIcon.vue'
import faIcon from './faIcon.vue'
import svgSprite from './svgSprite.vue'

import ideaBox from './ideaBox.vue'
import ideaCard from './ideaCard.vue'
import ideaModal from './ideaModal.vue'


import imageWrapper from './imageWrapper.vue'





const components = {
  navTop,
  navLeft,
  vueCalendar,
  vueDropdown,
  datePicker,
  postSticker,
  newIdeaModal,
  imageWrapper,
  adminModal,
  multiSelect,
  menuTop,
  svgIcon,
  svgSprite,
  confirmModal,
  faIcon,
  ideaBox,
  ideaCard,
  ideaModal,
}

const directives = {
  storage,
  touch,
  video,
}

export default {
  install(Vue) {
    Object.keys(components).map(name => Vue.component(name, components[name]))
    Object.keys(directives).map(name => Vue.directive(name, directives[name]))
  },
}
